<ion-avatar (click)="goToProfile()" class="user-avatar">
  <ion-avatar *ngIf="badge != null" class="avatar-badge">
    <img src="../../../assets/images/badge-images/{{badge.IMG}}"  />
  </ion-avatar>
  <img *ngIf="avatarUrl$ | async as url" [src]="url">
</ion-avatar>
